module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/317.d6e3556c.png";